export default __webpack_public_path__ + "static/media/promotion_about_title_bg.782cc217.svg";